// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__FryQl","productName":"Table_productName__op_0j"};